export class MessageContact {
  emailUtilisateur: string;
  objet: string;
  message: string;
}
